/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateStudentResponse
 */
export interface CreateStudentResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateStudentResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentResponse
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentResponse
     */
    entityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the CreateStudentResponse interface.
 */
export function instanceOfCreateStudentResponse(value: object): value is CreateStudentResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateStudentResponseFromJSON(json: any): CreateStudentResponse {
    return CreateStudentResponseFromJSONTyped(json, false);
}

export function CreateStudentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStudentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
    };
}

export function CreateStudentResponseToJSON(json: any): CreateStudentResponse {
    return CreateStudentResponseToJSONTyped(json, false);
}

export function CreateStudentResponseToJSONTyped(value?: CreateStudentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'entityId': value['entityId'],
        'displayName': value['displayName'],
    };
}

